export default __webpack_public_path__ + "static/media/Bedroom2EnSuite.9d0aecb3.png";